import { Dic } from '$utils'
const tableOption = {
  page: true,
  selection: false,
  index: false,
  column: [
    {
      label: '巡检计划ID',
      prop: 'planCode',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: true,
      overHidden: true,
      span: 24
    }, {
      label: '巡检计划名称',
      prop: 'planName',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 24
    }, {
      label: '巡检周期',
      prop: 'planCycle',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 24,
      formatter: function (row, value) {
        return value ? Dic.findByValue('SENU106', value) : '';
      }
    }, {
      label: '巡检时间',
      prop: 'cycleTimes',
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      overHidden: true,
      span: 24
    }
  ]
};
export default tableOption;
